var heading_default = {
  "fontElementMap": "Jm9WX",
  "elementSpacing": "XMpE9",
  "headerOne": "oHEKo XMpE9",
  "headerTwo": "cqXpV XMpE9",
  "headerThree": "ZSacP XMpE9",
  "headerFour": "b3gxk XMpE9",
  "headerFive": "_5y4fX XMpE9",
  "headerSix": "Nn24t XMpE9",
  "child": "uZXi0"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading.scss.js.map
